import { Autolinker } from 'autolinker';
import { Link } from '@hotjar/hotsauce';
import type { ReactNode } from 'react';
import { Fragment } from 'react';

export function TextWithLinks({ children }: { children?: ReactNode }): JSX.Element {
  if (typeof children !== 'string') return <>{children}</>;

  const content = children;

  const matches = Autolinker.parse(content, {});

  if (matches.length === 0) return <>{content}</>;

  let position = 0;

  const elements = matches.map((match) => {
    const offset = match.getOffset();
    const matchElements = (
      <Fragment key={position}>
        {position !== offset && content.substring(position, offset)}
        <Link kind="inline" isExternal href={match.getAnchorHref()}>
          {match.getMatchedText()}
        </Link>
      </Fragment>
    );

    position = match.getOffset() + match.getMatchedText().length;

    return matchElements;
  });

  if (position < content.length) {
    elements.push(
      <Fragment key={position}>{content.substring(position, content.length)}</Fragment>,
    );
  }

  return <>{elements}</>;
}
